import { faQuestionCircle as solidQuestionCircle } from "@jewlr/pro-solid-svg-icons/faQuestionCircle"
import { FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { FeesWrap, Text, Tooltip } from "areas/order/components"

const ExchangeFees = ({ item, selectedSize }) => (
  <FeesWrap>
    <Text mb="10px">
      <strong>Exchange Fee:</strong>{" "}
      <span className="fee-exchange">{selectedSize.fees.exchange_fee}</span>
    </Text>
    {item.resize_info?.has_base_engraving && (
      <>
        <Text mb="10px">
          <strong>Re-engraving Fee:</strong>{" "}
          <span className="fee-reengraving">
            {selectedSize.fees.reengraving_fee}
          </span>{" "}
          <FontAwesomeIcon
            data-for="reengraving_fee"
            data-tip
            icon={solidQuestionCircle}
          />
        </Text>
        <Tooltip id="reengraving_fee">
          Your item has a custom base (inside the ring) engraving. We will need
          to re-engrave the inside of the ring.
        </Tooltip>
      </>
    )}
    {selectedSize.price > 0 && (
      <Text mb="10px">
        <strong>Size Surcharge:</strong>{" "}
        <span className="fee-size-surcharge">{selectedSize.fees.price}</span>
      </Text>
    )}
    <Text mb="10px">
      <strong>Insured Shipping:</strong>{" "}
      <span className="fee-shipping">
        {selectedSize.fees.two_way_shipping_fee ||
          selectedSize.fees.shipping_fee}
      </span>{" "}
      <FontAwesomeIcon
        data-for="insured_shipping"
        data-tip
        icon={solidQuestionCircle}
      />
    </Text>
    <Tooltip id="insured_shipping">
      The Shipping fee is for a Secure Return Shipping Service to send the ring
      back to you. The package is insured for the full value -{" "}
      <em>
        <strong>so you have nothing to worry about.</strong>
      </em>
    </Tooltip>
    <Text mb="10px">
      <strong>{selectedSize.fees.tax_label}</strong>{" "}
      <span className="fee-tax">
        {selectedSize.fees.two_way_shipping_fee
          ? selectedSize.fees.tax_amount_two_way
          : selectedSize.fees.tax_amount}
      </span>
    </Text>
    <Text>
      <strong>Total:</strong>{" "}
      <span className="fee-total">
        {selectedSize.fees.two_way_shipping_fee
          ? selectedSize.fees.total_cost_two_way
          : selectedSize.fees.total_cost}
      </span>
    </Text>
  </FeesWrap>
)

ExchangeFees.propTypes = {
  item: PropTypes.object,
  selectedSize: PropTypes.object,
}

export default ExchangeFees
